import { createContext } from 'react';
import { CancelToken } from 'axios';

export type CapacityCancellationContextValue = {
  getCancelToken: () => CancelToken | undefined;
  cancelInFlightRequests: () => void;
};

export const CapacityCancellationContext =
  createContext<CapacityCancellationContextValue | null>(null);
